import { useOnline } from "@/hooks/useOnline";

export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="border-y border-clay/30 bg-clay/10 px-4 py-2 text-center text-sm text-clay"
    >
      Offline — showing saved prayer times
    </div>
  );
}
